import { captureGridHistoryState, getGridHistoryScene } from './gridHistory';

/** Last fully committed editor state — baseline for the next undo step. */
let lastCommittedSnapshot = null;

export function getLastCommittedGridHistory() {
  return lastCommittedSnapshot;
}

export function setLastCommittedGridHistory(snapshot) {
  lastCommittedSnapshot = snapshot || null;
}

export function clearLastCommittedGridHistory() {
  lastCommittedSnapshot = null;
}

/** Capture current scene/redux as the baseline for future edits. */
export function refreshLastCommittedGridHistory(scene = getGridHistoryScene()) {
  if (!scene) {
    lastCommittedSnapshot = null;
    return null;
  }
  lastCommittedSnapshot = captureGridHistoryState(scene);
  return lastCommittedSnapshot;
}
